import { useLayoutEffect, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { routeConstants } from 'shared/constants';
import {
  checkAuth,
  userLogout,
  resetLogoutRedirection,
  fetchCartCount,
} from 'store/actions';
import Navbar from './Navbar/Navbar';
import HeaderMid from './HeaderMid/HeaderMid';
import HeaderTop from './HeaderTop/HeaderTop';

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [menuActive, setMenuActive] = useState(false);
  const authUser = useSelector((state) => state.auth.user);
  const redirection = useSelector((state) => state.auth.redirection);

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  useEffect(() => {
    if (authUser) {
      dispatch(fetchCartCount());
    }
  }, [dispatch, authUser]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.remove('body_overlay');
    setMenuActive(false);
  }, [location]);

  useEffect(() => {
    if (redirection) {
      dispatch(resetLogoutRedirection());
      history.replace(routeConstants.AUTH.subRoutes.LOGIN.path);
    }
  }, [redirection, dispatch, history]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(userLogout());
  };

  const handleMobileMenuSwitch = (e) => {
    if (e) {
      e.preventDefault();
    }

    setMenuActive((prevState) => {
      if (prevState) {
        document.body.classList.remove('body_overlay');
      } else {
        document.body.classList.add('body_overlay');
      }
      return !prevState;
    });
  };

  return (
    <header className="header_main">
      <HeaderTop />
      <HeaderMid
        onLogout={handleLogout}
        onMobileMenuSwitch={handleMobileMenuSwitch}
      />
      <Navbar sideMenuOpen={menuActive} onToggleMenu={handleMobileMenuSwitch} />
    </header>
  );
};

export default Header;
